import * as React from 'react';
import styled, { tstyled } from '../../theme';

const Container = tstyled<{ sendStatus: IState['sendStatus'] }>(styled.form)`
  margin: 0 auto;
  padding: ${props =>
    props.sendStatus === 'complete' ? '80px 0 30px;' : '30px 0 80px'};
  transition: 0.3s ease transform 0.7s, 0.3s ease padding 0.7s;
  transform: ${props =>
    props.sendStatus === 'complete' ? 'scaleY(-1)' : 'none'};
  padding-left: ${props => props.theme.mobilePadding}px;
  padding-right: ${props => props.theme.mobilePadding}px;

  @media (min-width: ${props => props.theme.aboutBreakpoint}px) {
    width: 45%;
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;

const Info = styled.div`
  text-align: center;
  color: ${props => props.theme.color.body3};
  margin: 0 auto;

  @media (min-width: ${props => props.theme.aboutBreakpoint}px) {
    width: 390px;
  }
`;

const InputContainer = tstyled<{ sendStatus: IState['sendStatus'] }>(
  styled.div
)`
  justify-content: space-between;
  display: flex;
  margin-top: 20px;
  pointer-events: ${props =>
    props.sendStatus !== 'pending' ? 'none' : 'auto'};
  opacity: ${props => (props.sendStatus === 'sending' ? 0.6 : 1)};
  transition: 0.3s ease opacity;
`;

const Input = tstyled<{ isEmpty: boolean }>(styled.input)`
  border: none;
  border-bottom: 1px solid ${props => props.theme.color.body3};
  background-color: transparent;
  font-family: inherit;
  outline: none;
  color: ${props => props.theme.color.body3};
  width: 70%;
  font-size: inherit;

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }

  &::placeholder {
    color: ${props => props.theme.color.body3};
  }
`;

const Button = tstyled<{ isEmpty: boolean; sendStatus: IState['sendStatus'] }>(
  styled.button
)`
  border: 1px solid ${props => props.theme.color.body3};
  padding: 5px 10px;
  font-family: inherit;
  color: ${props => props.theme.color.body3};
  outline: none;
  transition: 0.3s ease color;
  cursor: pointer;
  font-size: inherit;
  background-color: transparent;
  transition: 0.2s ease color, 0.2s ease background-color;

  @media (min-width: ${props => props.theme.aboutBreakpoint}px) {
    width: 27%;
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }

  &:hover {
    background-color: ${props => props.theme.color.body3};
    color: #fff;
  }
`;

interface IState {
  email: string;
  sendStatus: 'pending' | 'sending' | 'complete';
}

class NewsletterSubscription extends React.Component<{}, IState> {
  state: IState = {
    email: '',
    sendStatus: 'pending',
  };

  private input: HTMLInputElement;

  sendRequest = (email: string) =>
    fetch('/newsletter-subscribe', {
      method: 'post',
      body: JSON.stringify({ email }),
      headers: { 'Content-Type': 'application/json' },
    });

  handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    this.input.blur();
    this.setState({ sendStatus: 'sending' });

    await this.sendRequest(this.state.email);

    this.setState({ sendStatus: 'complete' });
  };

  onEmailInput = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ email: e.currentTarget.value });
  };

  render() {
    const { email, sendStatus } = this.state;

    const isEmpty = email === '';
    let buttonText = 'Sign Up';
    switch (sendStatus) {
      case 'sending':
        buttonText = 'Sending...';
        break;
      case 'complete':
        buttonText = 'Sent';
        break;
    }

    return (
      <Container sendStatus={sendStatus} onSubmit={this.handleSubmit}>
        <Info>
          Sign up for occasional updates, announcements and special events.
        </Info>

        <InputContainer sendStatus={sendStatus}>
          <Input
            isEmpty={isEmpty}
            value={email}
            placeholder="Your Email Address"
            onChange={this.onEmailInput}
            type="email"
            required
            innerRef={ref => (this.input = ref)}
          />
          <Button sendStatus={sendStatus} isEmpty={isEmpty}>
            {buttonText}
          </Button>
        </InputContainer>
      </Container>
    );
  }
}

export default NewsletterSubscription;



// WEBPACK FOOTER //
// ./src/scenes/About/NewsletterSubscription.tsx